"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PageHeader() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [{
    label: "5 specialized processes"
  }, {
    label: "1000+ projects"
  }, {
    label: "12 industrial sectors"
  }];
  return <section data-section-id="542" id="page-header" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {}
        <div ref={imageRef} className={`relative h-[50vh] lg:h-auto overflow-hidden lg:rounded-r-lg transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_precision.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_precision.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_engraving_precision.png-wvc-sizes" alt="Precision laser engraving on industrial metal components" loading="lazy" decoding="async" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-tr from-background/40 via-transparent to-transparent pointer-events-none" />
        </div>

        {}
        <div ref={contentRef} className={`relative flex items-center bg-card transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="w-full px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-24 flex flex-col gap-10">
            {}
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-8 bg-primary" />
              <span className="font-default text-xs tracking-widest uppercase" style={{
              color: "var(--primary)"
            }}>
                Precision Marking
              </span>
            </div>

            {}
            <h1 className="font-default font-semibold text-foreground text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95]" style={{
            letterSpacing: "-0.04em"
          }}>
              Engineered for industrial durability.
            </h1>

            {}
            <p className="font-default text-base sm:text-lg text-muted-foreground max-w-md leading-relaxed">
              From high-precision laser engraving for critical components to rugged arc flash labels for electrical infrastructure, our marking solutions are built to withstand the harshest environments while meeting strict industry standards.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
              <Button asChild variant="ghost" className="h-auto px-0 py-2 justify-start text-foreground hover:bg-transparent hover:text-primary group">
                <Link to="/LaserEngravingMetalPage" className="flex items-center gap-3 border-b border-border hover:border-primary pb-2 transition-colors">
                  <span className="font-default text-base font-medium">Metal Engraving</span>
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="ghost" className="h-auto px-0 py-2 justify-start text-foreground hover:bg-transparent hover:text-primary group">
                <Link to="/ArcFlashLabelsPage" className="flex items-center gap-3 border-b border-border hover:border-primary pb-2 transition-colors">
                  <span className="font-default text-base font-medium">Arc Flash Labels</span>
                  <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-4 lg:mt-8 self-start lg:self-end">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}